import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedApproaches() {
  const failures = ['La terapia de pareja tradicional falló porque él manipuló al terapeuta para que tú parecieras la "inestable".', 'Intentar "explicarle" cómo te sientes no funcionó porque él usa tu vulnerabilidad como información para herirte mejor.', 'Leer consejos motivacionales en redes sociales te da alivio por 5 minutos, pero no detiene la taquicardia ni la niebla mental.', 'Esperar que pida perdón es esperar algo que su estructura cerebral no le permite sentir.', 'Analizar su pasado para "entenderlo" solo te mantuvo más tiempo siendo su enfermera emocional mientras él destruía tu autoestima.'];
  return <section className="py-24 px-4 bg-dark-800" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <FadeIn data-id="element-21">
          <h2 className="text-3xl md:text-4xl text-center mb-12" data-id="element-22">
            Por qué lo que has intentado no funciona
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-23">
          {failures.map((failure, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-24">
              <div className="flex items-start gap-4 bg-dark-900/50 p-6 rounded-lg border border-red-900/20" data-id="element-25">
                <XCircle className="w-6 h-6 text-red-500/80 shrink-0 mt-1" data-id="element-26" />
                <p className="text-offwhite/80 font-light text-lg leading-relaxed" data-id="element-27">
                  {failure}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}